import styled from 'styled-components';
import { Form as FormComponent } from '@unform/web';

import { colors, radius } from '../../../../styles/tokens';
import { InputCheckboxBox } from '../../../../components/InputCheckboxBox';
import { SeparateLabel } from '../../../../components/SeparateLabel';

export const EmailTag = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 8px;

  padding: 8px 14px;
  margin-bottom: 24px;

  background-color: ${colors.surfaceContainerHigh};
  border-radius: ${radius.full};

  span {
    font-size: 13px;
    font-weight: 500;
    color: ${colors.onSurfaceVariant};
  }
`;

export const Form = styled(FormComponent)`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const Row = styled.div`
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: 16px;

  @media (max-width: 1199px) {
    grid-template-columns: 1fr;
  }
`;

export const Row2 = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;

  @media (max-width: 1199px) {
    grid-template-columns: 1fr;
  }
`;

export const Separate = styled(SeparateLabel)`
  margin-top: 8px;
`;

export const ContainerCheckboxBox = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;

  label {
    font-size: 13px;
    line-height: 1.5;
    color: ${colors.onSurfaceVariant};

    a {
      color: ${colors.primary};
    }
  }
`;

export const Checkbox = styled(InputCheckboxBox)`
  margin-top: 2px;
`;
